.root {
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: inherit;
  height: 100%;
}
